import React, { useState } from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import { Typography } from '@material-ui/core';
import { WALLET_PAYMENTS } from '../../constants';

const Wallet = (props) => {
  const classes = props.classes;
  let config = tableConfig(props);
  //console.log("props",props)
  // console.log("props login",props.login)
  let session = sessionStorage.getItem('user');
  const [countryid, setCountryid] = useState(session ? `${JSON.parse(session).countryId}` : "");

  // if(role === "superadmin"){
  //    setCountryid(`${JSON.parse(session).countryId}`);
  // } 




  const onView = () => { props.onView() }

  return (<div>
    <div className={classes.tabRoot}>
      <h3> <strong>Payments received from Users</strong> </h3>
    </div>
    <Table
      noBorder={true}
      tableConfig={config}
      data={data}
      //onView={onView}
      apidata="payments"
      countryid={countryid}
      url={`${WALLET_PAYMENTS}/users`}
      localization={
        {
          header: {
            actions: ''
          }
        }
      }
    />
    <div className={classes.tabRoot}>
      <h3> <strong>Payments sent to Chefs</strong> </h3>
    </div>
    <Table
      noBorder={true}
      tableConfig={config}
      data={data}
      //onView={onView}
      apidata="payments"
      countryid={countryid}
      url={`${WALLET_PAYMENTS}/chefs`}
      localization={
        {
          header: {
            actions: ''
          }
        }
      }
    />
    <div className={classes.tabRoot}>
      <h3> <strong>Payments sent to Restaurants</strong> </h3>
    </div>
    <Table
      noBorder={true}
      tableConfig={config}
      data={data}
      //onView={onView}
      apidata="payments"
      countryid={countryid}
      url={`${WALLET_PAYMENTS}/restaurants`}
      localization={
        {
          header: {
            actions: ''
          }
        }
      }
    />
  </div>)
};

export default Wallet;
